import {AbstractModel} from './abstract-model';

export class TrackingDomain extends AbstractModel {
  id: number | null = null;
  domain: string | null = null;
  partnerId: number | null = null;
  productId: number | null = null;

  override toString(): string {
    return this.domain + (this.partnerId ? (' (#' + this.partnerId + ')') : '');
  }
}
